import { SavedLobby } from "../../types/multiplayer";
import { SavedLobbySchema } from "../../types/schemas/general";
import { MULTIPLAYER } from "../constants";

/**
 * Gets a saved lobby from local storage if there is one
 * that is not expired.
 *
 * @returns the saved lobby if it is valid, otherwise null
 */
export const getSavedLobby = (): SavedLobby | null => {
    const savedLobby = localStorage.getItem(MULTIPLAYER.LOBBY_STORAGE_KEY);
    if (!savedLobby) return null;

    const parsed = SavedLobbySchema.safeParse(JSON.parse(savedLobby));
    if (!parsed.success) return null;

    const { createdAt } = parsed.data;

    const isExpired = Date.now() - createdAt > MULTIPLAYER.LOBBY_STORAGE_EXPIRATION;

    if (isExpired) {
        removeSavedLobby();
        return null;
    }

    return parsed.data;
};

/**
 * Sets a new saved lobby session.
 *
 * @param lobbyId the lobbyId to save
 * @param userId the userId of the user in that lobbyId
 */
export const setSavedLobby = (lobbyId: string, username: string) => {
    const lobby = {
        lobbyId,
        username,
        createdAt: Date.now(),
    } satisfies SavedLobby;
    localStorage.setItem(MULTIPLAYER.LOBBY_STORAGE_KEY, JSON.stringify(lobby));
};

/**
 * Removes the saved lobby from local storage, if there is one.
 */
export const removeSavedLobby = (): void => {
    localStorage.removeItem(MULTIPLAYER.LOBBY_STORAGE_KEY);
};
